import { STATUS } from 'literals';

import * as types from 'types';

export const description = 'Coachbot';
export const name = 'Coachbot';
export const topic: types.Topic = {
  cached: false,
  data: [],
  message: '',
  status: STATUS.IDLE,
  updatedAt: 0,
};

export const grades = [
  {
    name: 'Session 1: Interests, Skills and Values',
    description: 'Explore my interests, skills and values to find possible future careers.',
    prompt: `Start with: "What do you like doing in your free time?"
Step 1: BigBrogrammer finds user's {interests}, identifies {skills} and {values} with questions like "What do you like doing?" "What are you good at?" "What do you care about?".
Step 2: BigBrogrammer describes two careers aligning {interests}, {values}, and {skills}, asks user's preference and their interest level in the job on a scale of 1-10.
Step 3: BigBrogrammer proposes a plan towards the preferred {target career}, identifies immediate {next steps} and gauges the likelihood of user taking them.
Step 4: Conversation summary using recorded data ({interests}, {skills}, {values}, {target career}, interest level, {next steps}, {likely_next_steps}) is prepared. BigBrogrammer encourages user to "Save" the chat`,
  },
  {
    name: 'Session 2: Future Lifestyle and Earnings',
    description: 'Imagine my future lifestyle and earnings',
    prompt: `Start with: "Welcome back! Thanks for exploring your interests, skills and values in our last chat. Now let's start imagining your future lifestyle and how to pay for it! How do you picture your future life?"
Step 1: BigBrogrammer explores user's {future lifestyle} (Imagine life at 30 or 40? Supporting a family or helping out your folks?) and probes for details ({housing}, {transportation}, {dependents}, {geography}).
Step 2: BigBrogrammer asks user's guess of cost for {future lifestyle}, then shares an estimated cost, asks for reactions, and offers a breakdown. The {future lifestyle} details might be revised.
Step 3: BigBrogrammer provides two career options with salaries for the estimated {future lifestyle cost}, asks preference and interest level 1-10. Continues until user is satisfied.
Step 4: Conversation summary including latest details is prepared. BigBrogrammer confirms contents, formats the summary, and encourages the user to save the chat.`,
  },
  {
    name: 'Session 3: Pathways from here to Career',
    description: 'Explore pathways from high school to possible careers',
    prompt: `Start with: "Welcome back! So far, we've explored your interests and income goals. Today, let's plan how to get you to that target career and lifestyle! If you're unsure about these, revisit our previous sessions. Now, what's your target career?"
Step 1: BigBrogrammer seeks {target career} that fits user's {interests}, {skills}, {values}, and {user estimated lifestyle cost}.
Step 2: BigBrogrammer compares {target career} salaries to {user estimated lifestyle cost}, prompts reaction, and offers career alternatives combining user's {interests}, {skills}, and desired {earnings}. User's preference and reasons are noted.
Step 3: BigBrogrammer asks for user's immediate and post-high school {next steps} towards {target career}. Two postsecondary pathways are proposed: a bachelor's degree, or a credential with work experience. User's preferred pathway and reasons are noted.
Step 4: Summary and Recommendations: BigBrogrammer summarizes conversation, formats the summary, and encourages user to "Save" the chat.`,
  },
];

export const coaches = [
  {
    name: 'BigBroGrammer',
    office: 'BigBroGrammer_Office',
    primary: '#358d92',
    default: '#4dadb3',
    chatbotId: 'OLxaEykwIXYHYxoN97jEN',
    voiceId: 'ErXwobaYiN019PkySvjV',
    voiceSettings: {
      stability: 0.19,
      similarity_boost: 0.69,
    },
    description:
      'Early career IT professional, BigBrogrammer uses Socratic questions to help you explore pathways and credentials to get you paid!',
  },
  {
    name: 'AuntiePrenneur',
    office: 'AuntiePrenneur_Office',
    primary: '#eb6550',
    default: '#f5806d',
    chatbotId: 'vemz2x1Y7JnB3WgMXOymH',
    voiceId: 'rla6jciKrNUTaXX8UA5W',
    voiceSettings: {
      stability: 0.42,
      similarity_boost: 0.59,
    },
    description:
      "She's launched successful businesses since high school. AuntiePrenneur wants you to blaze your own trail and find fulfillment!",
  },
];

export const initialMessages = new Array(grades.length);

// eslint-disable-next-line unicorn/prevent-abbreviations
for (let i = 0; i < grades.length; i++) {
  initialMessages[i] = new Array(coaches.length);

  // eslint-disable-next-line unicorn/prevent-abbreviations
  for (let j = 0; j < coaches.length; j++) {
    initialMessages[i][j] = new Array<types.MessageData>();
  }
}

export const initialQuestions = new Array(grades.length);

// eslint-disable-next-line unicorn/prevent-abbreviations
for (let i = 0; i < grades.length; i++) {
  initialQuestions[i] = new Array(coaches.length);
}
